import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";

const Addsalarycomponent = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const [componenttypes, setComponenttypes] = useState([]);
    const [calculationtypes, setCalculationtypes] = useState([]);
    const [componentcatgeorys, SetComponentcategorys] = useState([]);
    const [calculationbases, SetCalculationbases] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const routeLocation = useLocation();
    const [form, setForm] = useState({
        component_code: "",
        component_name: "",
        component_type_id: "",
        component_category_id: "",
        calculation_type_id: "",
        calculation_base_id: "",
        is_statutory: "",
        value: "",
        is_taxable: "",
        affects_pf: "",
        affects_esi: "",
        affects_pt: "",
        affects_gratuity: "",
        display_order: "",
        school_id: "",
    });



    useEffect(() => {
        if (routeLocation.state?.salaryData) {
            const salaryData = routeLocation.state.salaryData;


            const normalizedData = {
                ...salaryData,
                // is_statutory: salaryData.is_statutory === "Yes" ? "Y" : 
                //              salaryData.is_statutory === "No" ? "N" : 
                //              salaryData.is_statutory || "",
                is_taxable: salaryData.is_taxable === "Yes" ? "Y" :
                    salaryData.is_taxable === "No" ? "N" :
                        salaryData.is_taxable || "",
                // affects_pf: salaryData.affects_pf === "Yes" ? "Y" : 
                //            salaryData.affects_pf === "No" ? "N" : 
                //            salaryData.affects_pf || "",
                // affects_esi: salaryData.affects_esi === "Yes" ? "Y" : 
                //             salaryData.affects_esi === "No" ? "N" : 
                //             salaryData.affects_esi || "",
                // affects_pt: salaryData.affects_pt === "Yes" ? "Y" : 
                //           salaryData.affects_pt === "No" ? "N" : 
                //           salaryData.affects_pt || "",
                // affects_gratuity: salaryData.affects_gratuity === "Yes" ? "Y" : 
                //                 salaryData.affects_gratuity === "No" ? "N" : 
                //                 salaryData.affects_gratuity || "",
                is_active: salaryData.is_active === "Active" ? "A" :
                    salaryData.is_active === "Inactive" ? "I" :
                        salaryData.is_active || "A"
            };

            setForm(normalizedData);
            setEditId(salaryData.salary_component_id);
        }
    }, [routeLocation]);


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(baseUrl + "/component-types/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setComponenttypes(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const componentcategoryData = async () => {
        try {
            const response = await axios.get(baseUrl + "/component-category/", {
                action: "READ",
                school_id: userObj.school_id
            });

            SetComponentcategorys(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const calculationtypeData = async () => {
        try {
            const response = await axios.get(baseUrl + "/calculation-type/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setCalculationtypes(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };
    const calculationbaseData = async () => {
        try {
            const response = await axios.get(baseUrl + "/calculation-base/", {
                action: "READ",
                school_id: userObj.school_id
            });

            SetCalculationbases(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
        componentcategoryData();
        calculationtypeData();
        calculationbaseData();
    }, []);



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            component_code: form.component_code,
            component_name: form.component_name,
            component_type_id: form.component_type_id,
            component_category_id: form.component_category_id,
            calculation_type_id: form.calculation_type_id,
            calculation_base_id: form.calculation_base_id || 0,
            value: form.value || 0,
            is_taxable: form.is_taxable,
            display_order: form.display_order,
            school_id: userObj.school_id,
            is_active: form.is_active || "A",
            action: editId !== null ? 'UPDATE' : 'CREATE',
        };

        if (editId !== null) {
            formData.salary_component_id = editId;
        }

        try {
            const response = await axios.post(baseUrl + "/salarycomponent/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (editId !== null) {
                toast.success("Record Updated Successfully");
                setEditId(null);
            } else {
                toast.success("Record Added Successfully");
            }

            setForm({
                component_code: "",
                component_name: "",
                component_type_id: "",
                component_category_id: "",
                calculation_type_id: "",
                calculation_base_id: "",
                is_statutory: "",
                value: "",
                is_taxable: "",
                affects_pf: "",
                affects_esi: "",
                affects_pt: "",
                affects_gratuity: "",
                display_order: "",

            });

        } catch (error) {
            console.log("Full error object:", error);

            if (error.response) {
                const { status, data } = error.response;
                const errorMessage = data.error || data.message || "Unexpected error occurred";

                if (status === 409 && errorMessage.includes("Display Order already exists")) {
                    toast.error("Display Order already exists.", { position: "top-right" });
                } else if (status === 410 && errorMessage.includes("Record already exists")) {
                    toast.error("Record already exists.", { position: "top-right" });
                }
                else if (status === 500) {
                    toast.error("Error submitting data: " + errorMessage, { position: "top-right" });
                } else {
                    toast.error("Unexpected error occurred", { position: "top-right" });
                }
            } else {
                toast.error("Error submitting data: " + error.message, { position: "top-right" });
            }
        }
    };

    const isFixed = calculationtypes.some(
        (ct) =>
            String(ct.calculation_type_id) === String(form.calculation_type_id) &&
            ct.calculation_type_name === "Fixed"
    );
    return (
      

                <div className='pageBody'>
                    <ToastContainer />
                    <Container fluid>
                        <Card>
                            <Card.Body>
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Salary Component Details</h6>
                                        </Col>

                                    </Row>
                                    <Row>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Component Name <span className='requiredStar'>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="component_name"
                                                        value={form.component_name}
                                                        placeholder="Enter Component Name"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Component Code <span className='requiredStar'>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="component_code"
                                                        value={form.component_code}
                                                        placeholder="Enter Component Code"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Component Type<span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="component_type_id"
                                                        value={form.component_type_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Component Type</option>
                                                        {(componenttypes || [])

                                                            .map((componenttype) => (
                                                                <option key={componenttype.component_type_id} value={componenttype.component_type_id}>
                                                                    {componenttype.component_type_name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Component Category<span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="component_category_id"
                                                        value={form.component_category_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Component Category</option>
                                                        {(componentcatgeorys || [])

                                                            .map((componentcatgeory) => (
                                                                <option key={componentcatgeory.component_category_id} value={componentcatgeory.component_category_id}>
                                                                    {componentcatgeory.component_category_name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Calculation Type<span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="calculation_type_id"
                                                        value={form.calculation_type_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Calculation Type</option>
                                                        {(calculationtypes || []).map((calculationtype) => (
                                                            <option
                                                                key={calculationtype.calculation_type_id}
                                                                value={calculationtype.calculation_type_id}
                                                            >
                                                                {calculationtype.calculation_type_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Calculation Base<span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        id="calculation_base_id"
                                                        value={form.calculation_base_id}
                                                        onChange={handleInputChange}
                                                        disabled={isFixed}
                                                    >
                                                        <option value="">Select Calculation Base</option>
                                                        {(calculationbases || []).map((calculationbase) => (
                                                            <option
                                                                key={calculationbase.calculation_base_id}
                                                                value={calculationbase.calculation_base_id}
                                                            >
                                                                {calculationbase.calculation_base_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Value <span className="requiredStar">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="value"
                                                        value={form.value}
                                                        placeholder="Enter Value"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        disabled={isFixed}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " " && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        {/* <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '10px' }}>
                                                <Form.Label>
                                                    Is Statutory <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="is_statutory"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, is_statutory: "Y" }))}
                                                            checked={form.is_statutory === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="is_statutory"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, is_statutory: "N" }))}
                                                            checked={form.is_statutory === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Form.Group>
                                    </div>
                                </Col> */}

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <div style={{ marginLeft: '10px' }}>
                                                        <Form.Label>
                                                            Is Taxable <span className="requiredStar">*</span>
                                                        </Form.Label>
                                                        <div className="d-flex">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="is_taxable"
                                                                    id="Yes"
                                                                    value="Y"
                                                                    onChange={() => setForm(prev => ({ ...prev, is_taxable: "Y" }))}
                                                                    checked={form.is_taxable === "Y"}
                                                                    required
                                                                />

                                                                <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                            </div>
                                                            <div className="form-check ms-3">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="is_taxable"
                                                                    id="No"
                                                                    value="N"
                                                                    onChange={() => setForm(prev => ({ ...prev, is_taxable: "N" }))}
                                                                    checked={form.is_taxable === "N"}
                                                                />

                                                                <label className="form-check-label" htmlFor="No">No</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </Form.Group>
                                            </div>
                                        </Col>
                                        {/* <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '0px' }}>
                                                <Form.Label>
                                                    Affects Pf <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_pf"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_pf: "Y" }))}
                                                            checked={form.affects_pf === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_pf"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_pf: "N" }))}
                                                            checked={form.affects_pf === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '0px' }}>
                                                <Form.Label>
                                                    Affects Esi <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_esi"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_esi: "Y" }))}
                                                            checked={form.affects_esi === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_esi"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_esi: "N" }))}
                                                            checked={form.affects_esi === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '10px' }}>
                                                <Form.Label>
                                                    Affects Pt <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_pt"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_pt: "Y" }))}
                                                            checked={form.affects_pt === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_pt"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_pt: "N" }))}
                                                            checked={form.affects_pt === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Form.Group>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} lg={4} xxl={3}>
                                    <div className="commonInput">
                                        <Form.Group>
                                            <div style={{ marginLeft: '10px' }}>
                                                <Form.Label>
                                                    Affects Gratuity <span className="requiredStar">*</span>
                                                </Form.Label>
                                                <div className="d-flex">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_gratuity"
                                                            id="Yes"
                                                            value="Y"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_gratuity: "Y" }))}
                                                            checked={form.affects_gratuity === "Y"}
                                                            required
                                                        />

                                                        <label className="form-check-label" htmlFor="Yes">Yes</label>
                                                    </div>
                                                    <div className="form-check ms-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="affects_gratuity"
                                                            id="No"
                                                            value="N"
                                                            onChange={() => setForm(prev => ({ ...prev, affects_gratuity: "N" }))}
                                                            checked={form.affects_gratuity === "N"}
                                                        />

                                                        <label className="form-check-label" htmlFor="No">No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Form.Group>
                                    </div>
                                </Col> */}

                                        <Col xs={12} md={6} lg={4} xxl={2}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Display Order <span className='requiredStar'>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="display_order"
                                                        value={form.display_order}
                                                        placeholder="Enter Display Order"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Group>
                                            </div>
                                        </Col>



                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-info clearBtn"
                                                onClick={() => setForm({
                                                    component_code: "",
                                                    component_name: "",
                                                    component_type_id: "",
                                                    component_category_id: "",
                                                    calculation_type_id: "",
                                                    calculation_base_id: "",
                                                    is_statutory: "",
                                                    value: "",
                                                    is_taxable: "",
                                                    affects_pf: "",
                                                    affects_esi: "",
                                                    affects_pt: "",
                                                    affects_gratuity: "",
                                                    display_order: "",
                                                    school_id: "",

                                                })}

                                            >
                                                Reset
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-danger secondaryBtn me-2"
                                                onClick={() => window.history.back()}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="primary"
                                                className="btn-success primaryBtn"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </Card.Body>
                        </Card>
                    </Container>
                
        </div>

    );
};

export default Addsalarycomponent;